<template>
  <v-tooltip
    bottom>
    <template
      v-slot:activator="{ on, attrs }">

      <v-btn
        icon
        color="primary"
        v-bind="attrs"
        v-on="on"
        dark
        elevation="0"
        @click="onDialogButtonClick"
        small>

        <v-icon>{{icon}}</v-icon>

      </v-btn>

    </template>

    <!-- RAW形式で文字列展開 -->
    <span v-html="message"></span>

    <th-nippo-kamotsu-search-dialog
      :showDialog="showDialog"
      @close="onDialogClosed"/>
  </v-tooltip>
</template>
<script>
import inputMixin from '@/mixins/inputMixins'

const ThNippoKamotsuSearchDialog = () => import('@/components/ThNippoKamotsuSearchDialog')

export default {
  name: 'ThNippoKamotsuSearchButton',
  components: {
    ThNippoKamotsuSearchDialog
  },
  mixins: [inputMixin],
  props: {
    message: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    innerValue: '',
    showDialog: false
  }),
  created () {
    this.innerValue = this.value
  },
  mounted () {
  },
  computed: {
    computedProps () {
      return {
        ...this.$props
        // readonly: this.readonly
      }
    },
    computedListeners () {
      return {
        ...this.$listeners
      }
    },
    isHelpDisplay () {
      return this.readonly === false
    }
  },
  methods: {
    onDialogButtonClick: function (e) {
      this.showDialog = true
      console.log('dialog opend', e)
    },
    onDialogClosed: function (e) {
      console.log('dialog closed', e, this.showDialog)
      this.showDialog = false
      if (e === undefined) { return }
      this.numberSync(e)

      /**
       * dialog選択値inputイベント
       * @event input
       * @type {Event}
       * this.$emit('input', this.innerValue)
       */
    },
    numberSync: function (e) {
      console.log(' **** XXXXX **** kamotsuSync', e, this.showDialog)
      this.$emit('kamotsuSync', e)
    }
  }
}
</script>
<style scoped>

</style>
